import Button from "Components/Common/Button/Button";

interface Tab {
  id: string;
  label: string;
}

interface ViewTabsProps {
  tabs: Tab[];
  activeView: string;
  onChange: (id: string) => void;
}

const ViewTabs = ({ tabs, activeView, onChange }: ViewTabsProps) => {
  return (
    <div className="viewTabs">
      {tabs.map((tab) => (
        <Button
          key={tab.id}
          type="button"
          className={`viewTab ${activeView === tab.id ? "active" : ""}`.trim()}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </Button>
      ))}
    </div>
  );
};

export default ViewTabs;
